<template>
  <layout-component
    headerTitle="SOLICITUDES - GESTIÓN DE TIQUETES"
    headerSubTitle="Información general de permisos con tiquetes"
    :showLocation="false"
  >
    <template #container>
      <b-row class="mt-3">
        <b-col cols="12">
          <table-filter-component @update:selects="changeFilters" />
        </b-col>
        <b-col cols="12">
          <div class="d-flex justify-content-end mb-4">
            <button
              class="btn-reporte"
              @click.prevent="$refs.consolidatedReport.show()"
            >
              <img class="leftImg1" src="@/assets/images/icons/excel.svg" />
              <span class="ml-2"> Reporte Consolidado PS</span>
            </button>
          </div>
          <b-card>
            <b-card-text>
              <table-component
                :processing="getLicensesGetter.processing"
                :fields="fields"
                :items="getLicensesGetter.data.data"
              />
            </b-card-text>
          </b-card>
        </b-col>
        <b-col cols="12" class="mt-3 pb-5 mb-5">
          <vue-pagination-component
            align="center"
            :data="getLicensesGetter.data"
            @pagination-change-page="nextPage"
          />
        </b-col>
      </b-row>
      <modal-consolidated-report ref="consolidatedReport" />
    </template>
  </layout-component>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "index",
  data: () => ({
    processingPagination: false,
    filters: {},
  }),
  components: {
    layoutComponent: () =>
      import("@/layouts/modules/permisos-sindicales/v2/app.vue"),
    tableComponent: () =>
      import(
        "@/components/Modules/PermisosSindicales/Requests/GestorImpuestos/Table/Table.vue"
      ),
    tableFilterComponent: () =>
      import(
        "@/components/Modules/PermisosSindicales/Requests/GestorImpuestos/Table/Filter/Filter.vue"
      ),
    vuePaginationComponent: () => import("laravel-vue-pagination"),
    ModalConsolidatedReport: () => import("@/components/demands/Modal"),
  },
  computed: {
    ...mapGetters("permisosSindicalesV2License", ["getLicensesGetter"]),
    // ## Encabezado de la tabla
    fields() {
      return [
        {
          label: "ID",
          key: "id",
        },
        {
          label: "Sindicato",
          key: "labor_union",
        },
        {
          label: "Solicitante",
          key: "petitioner",
        },
        {
          label: "Fecha solicitud",
          key: "created",
        },
        {
          label: "Fecha aprobación",
          key: "approval_date",
        },
        {
          label: "Tiquetes solicitados",
          key: "count_all_tickets",
        },
        {
          label: "Tiquetes aprobados",
          key: "count_tickets",
        },
        {
          label: "Destino",
          key: "destination",
        },
        {
          label: "Estado gestión compra de tiquetes",
          key: "state_ticket",
        },
        {
          label: "",
          key: "options",
        },
      ];
    },
  },
  methods: {
    ...mapActions("permisosSindicalesV2License", ["getLicensesActions"]),
    nextPage(page = 1) {
      this.filters.page = page;
      this.getServer(this.filters);
    },
    getServer(data = {}) {
      if (this.validObjects(this.$route.query || {}, data))
        this.$router.replace({ query: data });
      this.getLicensesActions({ role: this.getCodeRoleCurrentUser, data });
    },
    // ## CUANDO CABIAN LOS FILTROS, LOS VALORES QUE VENGAN NULOS SE SACAN DEL OBJECTO
    changeFilters(data) {
      this.filters = this.reduceEntries(data);
      this.getServer(this.filters);
    },
    // ## RECORRE LAS EL OBJECTO Y DEVULVE AQUE SEA DIFERENTE DE NULL
    reduceEntries(values = {}) {
      return Object.entries(values).reduce((obj, [key, value]) => {
        if (value) obj[key] = value;
        return obj;
      }, {});
    },
  },
  mounted() {
    this.getServer(this.$route.query);
  },
};
</script>
<style lang="scss">
.card-body {
  padding: 0;
}
</style>
